module.exports = __webpack_public_path__ + "static/IMG_2468-4b317058c4bc19366a98f7c29677fd77.jpg";